/** Shared loading / error / empty states for every network-backed screen. */
import { Button } from '@astryxdesign/core/Button';
import { Center } from '@astryxdesign/core/Center';
import { EmptyState } from '@astryxdesign/core/EmptyState';
import { Icon } from '@astryxdesign/core/Icon';
import { Skeleton } from '@astryxdesign/core/Skeleton';
import { Spinner } from '@astryxdesign/core/Spinner';
import { VStack } from '@astryxdesign/core/Layout';
import { WifiSlash, WarningCircle } from '@phosphor-icons/react';
import { errorText } from '@/lib/api.ts';

export function LoadingView({ label = 'Загрузка', fullScreen = false }: { label?: string; fullScreen?: boolean }) {
  return (
    <Center height={fullScreen ? '100dvh' : 240}>
      <Spinner size="lg" label={label} />
    </Center>
  );
}

export function ErrorView({ error, onRetry, fullScreen = false }: { error: unknown; onRetry?: () => void; fullScreen?: boolean }) {
  const offline = typeof navigator !== 'undefined' && navigator.onLine === false;
  return (
    <Center height={fullScreen ? '100dvh' : undefined}>
      <EmptyState
        title={offline ? 'Нет подключения к интернету' : 'Не удалось загрузить'}
        description={offline ? 'Проверьте связь и попробуйте снова.' : errorText(error)}
        icon={<Icon icon={offline ? WifiSlash : WarningCircle} size="lg" />}
        actions={onRetry ? <Button label="Повторить" variant="primary" onClick={onRetry} /> : undefined}
      />
    </Center>
  );
}

export function ListSkeleton({ rows = 4 }: { rows?: number }) {
  return (
    <VStack gap={3} padding={4} aria-busy="true" aria-label="Загрузка">
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} index={i} height={56} radius={3} />
      ))}
    </VStack>
  );
}
